import { createFileRoute } from '@tanstack/react-router'
import { CentralDeNotas } from '../../../app/financial/central-de-notas'

export const Route = createFileRoute('/_auth/financial/central-de-notas')({
  component: CentralDeNotas,
})
